module.exports = __webpack_public_path__ + "img/equipment-search.486cc100.svg";